export default "__VITE_ASSET__BugpBfGx__"